import { forwardRef } from "react";

import { ColorIcon } from "src/design-system/ColorIcon";
import { type IndicatorColor } from "src/design-system/utils/colorPalette";

export type StatusIconVariant = "published" | "draft" | "review" | "archived";

type StatusIconSize = "3xs" | "2xs" | "xs";

type StatusIconProps = {
  variant: StatusIconVariant;
  size?: StatusIconSize;
  dataLoc?: string;
};

const VARIANT_TO_COLOR: Record<StatusIconVariant, IndicatorColor> = {
  published: "green-500",
  draft: "yellow-500",
  review: "indigo-400",
  archived: "gray-400",
} as const;

export const StatusIcon = forwardRef<HTMLSpanElement, StatusIconProps>(
  ({ variant, size = "3xs", dataLoc }, ref) => (
    <ColorIcon
      ref={ref}
      color={VARIANT_TO_COLOR[variant]}
      dataLoc={dataLoc}
      size={size}
    />
  ),
);
